import React, { useRef } from 'react';
import '../App.css';

// 🔹 Importar imágenes de Licenciados (agrega las tuyas)
import Lic01 from '../img/Licenciatura 8° 2024.jpeg';
import Lic02 from '../img/Graduación Kinder 2024.jpg';
import Lic03 from '../img/Licenciatura 8vo básico 2025.JPG';
import Lic04 from '../img/Kinder 2025.jpg';

const LicenciadosComponent = () => {
  const scrollRef = useRef(null);

  const licenciadosData = [

    {
      id: 4,
      date: 'Graduación Kinder 2025',
      title: '',
      description: '',
      imageUrl: Lic04,
      type: 'image',
    },

    {
      id: 3,
      date: 'Licenciatura 8° Básico 2025',
      title: '',
      description: '',
      imageUrl: Lic03,
      type: 'image',
    },


    {
      id: 2,
      date: 'Graduación Kinder 2024',
      title: '',
      description: '',
      imageUrl: Lic02,
      type: 'image',
    },

    {
      id: 1,
      date: 'Licenciatura 8° Básico 2024',
      title: '',
      description: '',
      imageUrl: Lic01,
      type: 'image',
    },

    
    
  ];

  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  return (
    <div id="licenciados-component" className="events-component">
      <h2>Licenciados & Graduados (Doble clic para ampliar)</h2>

      <div className="carousel-container no-arrows">
        <div className="event-cards-container large-cards" ref={scrollRef}>
          {licenciadosData.map((item) => (
            <div key={item.id} className="event-card large-card licenciados-card">
              <div className="event-date licenciados-date">{item.date}</div>
              <div className="event-details">
                <h3>{item.title}</h3>
                <p className="event-description">{item.description}</p>
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="honor-image large-image"
                  onDoubleClick={() => openFileInNewTab(item.imageUrl)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LicenciadosComponent;
